(function () {
  function initReveal(scope) {
    scope = scope || document;
    scope
      .querySelectorAll('.circles-head, .bs-head, .camp .overlay, .collection-banner .inner, .room-list, .gal-head, .email, .svc-grid')
      .forEach(function (el) { el.classList.add('reveal'); });
    scope
      .querySelectorAll('.circle-row, .bs-grid, .gal-grid')
      .forEach(function (el) { el.classList.add('reveal-stagger'); });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    scope.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var heroMedia = document.querySelector('.hero svg, .hero img.hero-media');
    if (heroMedia && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.addEventListener(
        'scroll',
        function () {
          var y = window.scrollY;
          if (y < 800) { heroMedia.style.transform = 'translateY(' + y * 0.18 + 'px)'; }
        },
        { passive: true }
      );
    }
  }

  function init() {
    initReveal(document);
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run animations when sections are (re)loaded in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    e.target.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) { el.classList.add('in'); });
    initParallax();
  });
})();

/* ---- Announcement bar marquee: measures the real content width and clones
   it just enough times to cover the bar (no gap on short content), keeps
   scrolling through hover, and is tuned to avoid layout/paint jank:
   - only clones enough copies for one extra buffer unit, not a full 2x
   - promotes the track to its own GPU layer (translateZ/backface-hidden)
   - contains layout/paint to the bar so resize recalculation stays cheap
   - skips recompute on resize events that don't actually change the width ---- */
(function () {
  function computePromo(root) {
    var track = root.querySelector('[data-promo-track]');
    var unit = root.querySelector('[data-promo-unit]');
    if (!track || !unit) return;

    track.classList.remove('is-animating');
    Array.prototype.slice.call(track.querySelectorAll('[data-promo-clone]')).forEach(function (el) {
      el.parentNode.removeChild(el);
    });

    var unitWidth = unit.getBoundingClientRect().width;
    if (!unitWidth) return;
    var containerWidth = root.getBoundingClientRect().width;

    // One extra buffer unit beyond the visible bar width is enough to loop
    // seamlessly (translating by exactly one unit width always leaves the
    // visible area filled) — cloning to 2x was unnecessary DOM/paint cost.
    var totalWidth = unitWidth;
    var guard = 0;
    while (totalWidth < containerWidth + unitWidth && guard < 24) {
      var clone = unit.cloneNode(true);
      clone.setAttribute('data-promo-clone', 'true');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      totalWidth += unitWidth;
      guard++;
    }

    track.style.setProperty('--promo-distance', '-' + unitWidth + 'px');
    var pxPerSecond = 40;
    track.style.setProperty('--promo-duration', (unitWidth / pxPerSecond) + 's');

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Force a reflow so the animation restarts cleanly with the new
      // custom-property values instead of continuing a stale run.
      void track.offsetWidth;
      track.classList.add('is-animating');
    }
  }

  function initPromoMarquee(root) {
    computePromo(root);

    var lastWidth = root.getBoundingClientRect().width;
    var resizeTimer = null;
    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var w = root.getBoundingClientRect().width;
          // Skip rebuilding when the width hasn't meaningfully changed (mobile
          // browsers fire resize on address-bar show/hide with no real width
          // change) — avoids unnecessary clone/reflow work.
          if (Math.abs(w - lastWidth) < 2) return;
          lastWidth = w;
          computePromo(root);
        }, 200);
      },
      { passive: true }
    );

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { computePromo(root); });
    }
  }

  function initAllPromo(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-promo-marquee]:not([data-promo-bound])').forEach(function (root) {
      root.setAttribute('data-promo-bound', 'true');
      initPromoMarquee(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllPromo(document); });
  } else {
    initAllPromo(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAllPromo(e.target); });
})();

/* ---- Product page: gallery, variant picker, quantity stepper ---- */
(function () {
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initGallery(root) {
    if (root.dataset.pdpGalleryInit === 'true') return;
    var thumbsWrap = root.querySelector('.pdp-thumbs');
    var slidesWrap = root.querySelector('.pdp-main-image');
    if (!thumbsWrap || !slidesWrap) return;
    var thumbs = Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-pdp-thumb]'));
    var slides = Array.prototype.slice.call(slidesWrap.querySelectorAll('[data-pdp-slide]'));
    if (!thumbs.length || !slides.length) return;

    function activate(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      applyActiveFit(root);
    }

    thumbsWrap.addEventListener('click', function (e) {
      var thumb = e.target.closest ? e.target.closest('[data-pdp-thumb]') : null;
      if (!thumb) return;
      e.preventDefault();
      var index = thumbs.indexOf(thumb);
      if (index > -1) activate(index);
    });

    // Optional prev/next arrows on the main image (Corduroy Loveseat gallery).
    var mainPrev = slidesWrap.querySelector('[data-pdp-main-prev]');
    var mainNext = slidesWrap.querySelector('[data-pdp-main-next]');
    function currentIndex() {
      var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      return i > -1 ? i : 0;
    }
    // When the color filter (see filterGalleryByColor below) has hidden some
    // thumbs, the arrows should only step through the ones still visible —
    // otherwise they'd flip to a different color's photo.
    function stepIndex(dir) {
      var visible = [];
      thumbs.forEach(function (t, i) { if (!t.classList.contains('is-hidden')) visible.push(i); });
      if (!visible.length) visible = thumbs.map(function (_, i) { return i; });
      var cur = currentIndex();
      var pos = visible.indexOf(cur);
      if (pos === -1) pos = 0;
      var nextPos = (pos + dir + visible.length) % visible.length;
      return visible[nextPos];
    }
    if (mainPrev) {
      mainPrev.addEventListener('click', function () {
        activate(stepIndex(-1));
      });
    }
    if (mainNext) {
      mainNext.addEventListener('click', function () {
        activate(stepIndex(1));
      });
    }

    applyImageFit(root);

    root.dataset.pdpGalleryInit = 'true';
  }

  // The main image frame's shape flexes to roughly match each photo's own
  // proportions, instead of forcing every photo into one fixed near-square
  // box. This is what actually avoids object-fit:cover's "zoom": cover only
  // has to scale an image up when the frame's aspect ratio doesn't match the
  // photo's — so once the frame *is* shaped like the photo, cover needs
  // little or no scale-up, and what little cropping remains reads as a true
  // trim rather than a magnified, cropped close-up. The ratio is clamped to
  // a sane range so an unusually tall or wide outlier photo doesn't force
  // the gallery box itself into an extreme shape.
  var PDP_FIT_MIN_RATIO = 0.75;
  var PDP_FIT_MAX_RATIO = 1.3;

  function clampFitRatio(w, h) {
    var r = w / h;
    return Math.max(PDP_FIT_MIN_RATIO, Math.min(PDP_FIT_MAX_RATIO, r));
  }

  // Precomputes and stores each photo's clamped ratio as soon as it has
  // loaded (so switching slides later is instant, no layout thrash), and
  // applies it immediately if that photo happens to already be the active
  // one (e.g. the first photo on initial page load).
  function applyImageFit(root) {
    var imgs = Array.prototype.slice.call(root.querySelectorAll('.pdp-slide img'));
    if (!imgs.length) return;

    function decide(img) {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h) return;
      img.dataset.fitRatio = clampFitRatio(w, h);
      img.classList.add('pdp-fit-cover');
      applyActiveFit(root);
    }

    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth) {
        decide(img);
      } else {
        img.addEventListener('load', function () { decide(img); }, { once: true });
      }
    });
  }

  // Sets the main image frame's aspect-ratio to whatever the currently
  // active slide's photo already computed above. Called any time the active
  // slide changes (thumb click, prev/next arrows, variant swap) as well as
  // right after a photo finishes loading. If the active photo hasn't loaded
  // yet, the frame just keeps its CSS default shape until it does.
  function applyActiveFit(root) {
    var mainImage = root.querySelector('.pdp-main-image');
    var activeImg = root.querySelector('.pdp-slide.is-active img');
    if (!mainImage || !activeImg) return;
    if (activeImg.dataset.fitRatio) {
      mainImage.style.aspectRatio = activeImg.dataset.fitRatio;
    }
  }

  // Switches the gallery's active thumb/slide to whichever one carries a
  // matching data-media-file — used to sync the gallery when a shopper picks
  // a variant that has its own featured image (e.g. a color swatch with
  // a dedicated photo). Matched by filename rather than ID: variant.featured_image.id is a
  // legacy ProductImage ID while product.media[].id is a MediaImage ID —
  // different ID spaces that never coincide — but both reference the same
  // underlying file, so the filename is the reliable common key.
  function activateGalleryByFilename(root, filename) {
    if (!filename) return;
    var thumbsWrap = root.querySelector('.pdp-thumbs');
    var slidesWrap = root.querySelector('.pdp-main-image');
    if (!thumbsWrap || !slidesWrap) return;
    var thumbs = Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-pdp-thumb]'));
    var slides = Array.prototype.slice.call(slidesWrap.querySelectorAll('[data-pdp-slide]'));
    if (!thumbs.length || !slides.length) return;
    var index = thumbs.findIndex(function (t) { return t.getAttribute('data-media-file') === filename; });
    if (index === -1) return;
    thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    applyActiveFit(root);
  }

  // Normalizes a color string for comparison: trims, lowercases, and
  // collapses any run of internal whitespace to a single space (some
  // variant option values in Shopify admin carry accidental double spaces,
  // e.g. "New  Light Green" — this keeps matching robust either way).
  function normalizeColor(value) {
    return (value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  // Switches the gallery's active thumb/slide to the first one tagged with
  // the given color via data-media-color (which mirrors each image's alt
  // text set in Shopify admin). This is the fallback used when a variant
  // has no featured_image of its own assigned in Shopify admin — it lets a
  // color swatch click still swap the hero photo, driven purely off image
  // alt text rather than requiring per-variant image assignment. Returns
  // true if a match was found and applied.
  function activateGalleryByColor(root, color) {
    if (!color) return false;
    var thumbsWrap = root.querySelector('.pdp-thumbs');
    var slidesWrap = root.querySelector('.pdp-main-image');
    if (!thumbsWrap || !slidesWrap) return false;
    var thumbs = Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-pdp-thumb]'));
    var slides = Array.prototype.slice.call(slidesWrap.querySelectorAll('[data-pdp-slide]'));
    if (!thumbs.length || !slides.length) return false;
    var norm = normalizeColor(color);
    var index = thumbs.findIndex(function (t) {
      return normalizeColor(t.getAttribute('data-media-color')) === norm;
    });
    if (index === -1) return false;
    thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    applyActiveFit(root);
    return true;
  }

  // Hides thumbs/slides that don't belong to the given color (matched via the
  // data-media-color attribute, which mirrors each image's alt text set in
  // Shopify admin). Products that were never tagged with a color per image
  // (i.e. no thumb has data-media-color at all) are left showing everything,
  // as are colors with no tagged match — both are safety fallbacks so a
  // product without this metadata never ends up with an empty gallery.
  function filterGalleryByColor(root, color) {
    var thumbsWrap = root.querySelector('.pdp-thumbs');
    var slidesWrap = root.querySelector('.pdp-main-image');
    if (!thumbsWrap || !slidesWrap) return;
    var thumbs = Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-pdp-thumb]'));
    var slides = Array.prototype.slice.call(slidesWrap.querySelectorAll('[data-pdp-slide]'));
    if (!thumbs.length) return;

    function showAll() {
      thumbs.forEach(function (t) { t.classList.remove('is-hidden'); });
      slides.forEach(function (s) { s.classList.remove('is-hidden'); });
    }

    var hasAnyColorTag = thumbs.some(function (t) { return (t.getAttribute('data-media-color') || '').length; });
    if (!hasAnyColorTag || !color) { showAll(); return; }

    var norm = normalizeColor(color);
    var matchExists = thumbs.some(function (t) {
      return normalizeColor(t.getAttribute('data-media-color')) === norm;
    });
    if (!matchExists) { showAll(); return; }

    thumbs.forEach(function (t) {
      var match = normalizeColor(t.getAttribute('data-media-color')) === norm;
      t.classList.toggle('is-hidden', !match);
    });
    slides.forEach(function (s) {
      var match = normalizeColor(s.getAttribute('data-media-color')) === norm;
      s.classList.toggle('is-hidden', !match);
    });
  }

  // Reads the currently-selected value from the "Color"/"Colour" swatch
  // group specifically (as opposed to any other option like Size), so the
  // gallery filter above always keys off color even on products with more
  // than one option.
  function getSelectedColorValue(root) {
    var swatchGroup = root.querySelector('.pdp-option-values.pdp-swatches');
    if (!swatchGroup) return null;
    var selected = swatchGroup.querySelector('.is-selected');
    return selected ? selected.getAttribute('data-pdp-option-select') : null;
  }

  function initQuantity(root) {
    var qtyInput = root.querySelector('[data-pdp-qty-input]');
    var decrease = root.querySelector('[data-pdp-qty-decrease]');
    var increase = root.querySelector('[data-pdp-qty-increase]');
    if (!qtyInput) return;
    if (decrease) {
      decrease.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
    }
    if (increase) {
      increase.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }
  }

  function initVariantPicker(root, sectionId) {
    var optionGroups = root.querySelectorAll('[data-pdp-option]');
    if (!optionGroups.length) return;

    var variantSelect = root.querySelector('[data-pdp-variant-select]');
    var variantIdInput = root.querySelector('[data-pdp-variant-id]');
    var priceEl = root.querySelector('#price-' + sectionId);
    var addButton = root.querySelector('[data-pdp-add-to-cart]');
    var addLabel = root.querySelector('[data-pdp-add-label]');

    var variantsScript = document.querySelector('[data-pdp-variants="' + sectionId + '"]');
    var variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent); } catch (err) { variants = []; }
    }

    function currentSelections() {
      var selections = [];
      optionGroups.forEach(function (group) {
        var selected = group.querySelector('.is-selected');
        selections.push(selected ? selected.getAttribute('data-pdp-option-select') : null);
      });
      return selections;
    }

    function findMatchingVariant(selections) {
      if (variants.length) {
        for (var i = 0; i < variants.length; i++) {
          var opts = variants[i].options || [];
          var match = true;
          for (var j = 0; j < selections.length; j++) {
            if (selections[j] !== null && opts[j] !== selections[j]) { match = false; break; }
          }
          if (match) return variants[i];
        }
        return null;
      }
      // fallback: match against the hidden <select> options
      if (!variantSelect) return null;
      var joined = selections.join('||');
      var opt = Array.prototype.find.call(variantSelect.options, function (o) {
        return o.getAttribute('data-options') === joined;
      });
      return opt ? { id: opt.value, available: !opt.disabled } : null;
    }

    function updateUI(variant) {
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl && variant.price) {
        priceEl.innerHTML =
          variant.compare_at_price && variant.compare_at_price > variant.price
            ? '<span class="sale">' + formatMoney(variant.price) + '</span><span class="reg">' + formatMoney(variant.compare_at_price) + '</span>'
            : '<span>' + formatMoney(variant.price) + '</span>';
      }
      // If this variant has its own featured image (e.g. a color swatch with
      // a dedicated photo assigned in Shopify admin), swap the gallery to
      // that image/thumb. Otherwise, fall back to matching a photo by color
      // via each image's alt text — this is what makes clicking a color
      // swatch switch the hero image even when no per-variant image has
      // been assigned to that variant in Shopify admin.
      if (variant.featured_image && variant.featured_image.src) {
        var srcParts = variant.featured_image.src.split('?')[0].split('/');
        var filename = srcParts[srcParts.length - 1];
        activateGalleryByFilename(root, filename);
      } else {
        activateGalleryByColor(root, getSelectedColorValue(root));
      }
      // Only show the thumbs/slides that belong to the selected color —
      // done after activateGalleryByFilename/activateGalleryByColor above so
      // the active slide is already correct before hidden ones get filtered
      // out.
      filterGalleryByColor(root, getSelectedColorValue(root));
      var available = variant.available !== false;
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to Cart' : 'Sold Out';
    }

    optionGroups.forEach(function (group) {
      var buttons = group.querySelectorAll('[data-pdp-option-select]');
      var valueLabel = group.querySelector('[data-pdp-option-value]');
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          buttons.forEach(function (b) { b.classList.remove('is-selected'); });
          button.classList.add('is-selected');
          if (valueLabel) valueLabel.textContent = button.getAttribute('data-pdp-option-select');
          var variant = findMatchingVariant(currentSelections());
          updateUI(variant);
        });
      });
    });

    // Sync the gallery (and price/availability) to the variant that's
    // already selected on page load — without this, a product whose default
    // color has its own featured image shows the wrong photo until the
    // shopper clicks a swatch, since updateUI was previously only wired to
    // the click handlers above.
    updateUI(findMatchingVariant(currentSelections()));

    initGallery(root);
    initQuantity(root);
  }

  function initAllProductForms() {
    document.querySelectorAll('.pdp').forEach(function (root) {
      var form = root.querySelector('.pdp-form');
      if (!form) return;
      var sectionId = form.getAttribute('id').replace('pdp-form-', '');
      initVariantPicker(root, sectionId);
      initGallery(root);
      initQuantity(root);
    });
  }

  /* ---- "Shop Similar Items" / "You May Also Like" wide carousel arrows ---- */
  function initSrcCarousels(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-src-wrap]:not([data-src-bound])').forEach(function (wrap) {
      wrap.setAttribute('data-src-bound', 'true');
      var row = wrap.querySelector('[data-src-row]');
      var prev = wrap.querySelector('[data-src-prev]');
      var next = wrap.querySelector('[data-src-next]');
      if (!row || !prev || !next) return;
      function scrollAmount() {
        var card = row.querySelector('.src-card');
        return card ? card.getBoundingClientRect().width + 28 : 400;
      }
      prev.addEventListener('click', function () {
        row.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        row.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllProductForms();
      initSrcCarousels(document);
    });
  } else {
    initAllProductForms();
    initSrcCarousels(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('.pdp')) initAllProductForms();
    initSrcCarousels(e.target);
  });

  /* ---- "You May Also Like" — native Shopify product recommendations ---- */
  if (window.customElements && !customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        var el = this;
        var url = this.getAttribute('data-url');
        if (!url) return;
        fetch(url)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var recs = doc.querySelector('.pdp-recs');
            if (recs && recs.innerHTML.trim().length) {
              el.innerHTML = recs.outerHTML;
              // Content injected here arrives after the page's initial
              // IntersectionObserver pass, so ".reveal" elements would
              // otherwise sit at opacity:0 forever. Mark them visible now.
              el.querySelectorAll('.reveal, .reveal-stagger').forEach(function (n) {
                n.classList.add('in');
              });
              initSrcCarousels(el);
            } else {
              el.remove();
            }
          })
          .catch(function () { el.remove(); });
      }
    }
    customElements.define('product-recommendations', ProductRecommendations);
  }
})();

/* ---- Recently viewed products ---- */
(function () {
  var STORAGE_KEY = 'osko_recently_viewed';
  var MAX_ITEMS = 12;
  var SHOW_COUNT = 4;

  function readList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }

  function writeList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderStrip(container, items) {
    if (!items.length) {
      container.parentNode && container.parentNode.removeChild(container);
      return;
    }
    var html = '<div class="pdp-recs-head"><h3>Recently Viewed</h3></div><div class="pdp-recs-grid">';
    items.forEach(function (item) {
      html +=
        '<a href="' + escapeHtml(item.url) + '" class="pcard">' +
        '<div class="ph"><img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy"></div>' +
        '<div class="name">' + escapeHtml(item.title) + '</div>' +
        '<div class="price"><span>' + escapeHtml(item.price) + '</span></div>' +
        '</a>';
    });
    html += '</div>';
    container.innerHTML = html;
  }

  function init() {
    var scriptTag = document.querySelector('[data-current-product]');
    var container = document.querySelector('[data-recently-viewed]');
    if (!scriptTag || !container) return;

    var current;
    try { current = JSON.parse(scriptTag.textContent); } catch (e) { return; }
    if (!current || !current.handle) return;

    var list = readList();
    var others = list.filter(function (p) { return p && p.handle !== current.handle; }).slice(0, SHOW_COUNT);
    renderStrip(container, others);

    var updated = list.filter(function (p) { return p && p.handle !== current.handle; });
    updated.unshift(current);
    if (updated.length > MAX_ITEMS) updated = updated.slice(0, MAX_ITEMS);
    writeList(updated);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---- Loveseat reviews carousel: auto-rotates, arrows, dots, pauses on hover/focus ---- */
(function () {
  function initReviewsCarousel(root) {
    if (root.dataset.reviewsInit === 'true') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-review-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-review-dot]'));
    var prevBtn = root.querySelector('[data-review-prev]');
    var nextBtn = root.querySelector('[data-review-next]');
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function activate(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function start() {
      if (reduceMotion) return;
      stop();
      timer = setInterval(function () { activate(index + 1); }, 5000);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        activate(i);
        start();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        activate(index - 1);
        start();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        activate(index + 1);
        start();
      });
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    activate(0);
    start();
    root.dataset.reviewsInit = 'true';
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-reviews-carousel]').forEach(initReviewsCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* ---- Mobile menu drawer (hamburger toggle) ---- */
(function () {
  function setState(toggle, drawer, overlay, open) {
    drawer.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('mobile-drawer-open', open);
  }

  function init() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    var overlay = document.querySelector('[data-mobile-drawer-overlay]');
    var closeBtn = document.querySelector('[data-mobile-drawer-close]');
    if (!toggle || !drawer || !overlay) return;

    toggle.addEventListener('click', function () {
      setState(toggle, drawer, overlay, !drawer.classList.contains('is-open'));
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () { setState(toggle, drawer, overlay, false); });
    }
    overlay.addEventListener('click', function () { setState(toggle, drawer, overlay, false); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        setState(toggle, drawer, overlay, false);
      }
    });

    // If the shopper resizes past the phone breakpoint (or rotates a tablet)
    // while the drawer is open, close it so it doesn't get stuck open behind
    // the desktop layout, which has no toggle to close it with.
    window.addEventListener(
      'resize',
      function () {
        if (window.innerWidth > 749 && drawer.classList.contains('is-open')) {
          setState(toggle, drawer, overlay, false);
        }
      },
      { passive: true }
    );

    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setState(toggle, drawer, overlay, false); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---- Mobile sticky Add to Cart bar: mirrors the real PDP add-to-cart button
   so cart/variant logic stays in exactly one place. Shows once the shopper
   has scrolled past the primary add-to-cart row; hidden entirely above
   749px via CSS, where the button is already reachable in the layout. ---- */
(function () {
  function initStickyAtc(root) {
    var bar = root.querySelector('[data-pdp-sticky-atc]');
    var trigger = root.querySelector('[data-pdp-sticky-add]');
    var realButton = root.querySelector('[data-pdp-add-to-cart]');
    var watchTarget = root.querySelector('.pdp-qty-row') || realButton;
    var priceSource = root.querySelector('[id^="price-"]');
    var priceTarget = bar ? bar.querySelector('[data-pdp-sticky-price]') : null;
    if (!bar || !trigger || !realButton || !watchTarget) return;

    var mq = window.matchMedia('(max-width:749px)');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!mq.matches) {
            bar.classList.remove('is-visible');
            return;
          }
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -10% 0px' }
    );
    io.observe(watchTarget);

    trigger.addEventListener('click', function () {
      if (realButton.disabled) return;
      realButton.click();
    });

    // Only mirror the *active* price (sale price when one exists) into the
    // sticky bar — priceSource's markup can contain both a .sale span and a
    // struck-through .reg span when the product is on sale, and copying the
    // whole thing verbatim (as innerHTML) showed both prices concatenated in
    // the compact sticky bar instead of just the current price.
    if (priceSource && priceTarget) {
      var syncPrice = function () {
        var activeEl = priceSource.querySelector('.sale') || priceSource.querySelector('span:not(.reg)');
        var text = activeEl ? activeEl.textContent : priceSource.textContent;
        priceTarget.textContent = (text || '').trim();
      };
      syncPrice();
      new MutationObserver(syncPrice).observe(priceSource, { childList: true, subtree: true });
    }

    trigger.disabled = realButton.disabled;
    new MutationObserver(function () {
      trigger.disabled = realButton.disabled;
    }).observe(realButton, { attributes: true, attributeFilter: ['disabled'] });
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('.pdp').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
